import React from 'react'

import toast from 'react-hot-toast'

import { Input, Section, SectionSubtitle } from '../..'
import { useChallenge } from '../../../context'
import { useStudents } from '../../../hooks/useStudents'
import { ChallengeStatus } from '../../../types'
import { capitalizeFirstLetter } from '../../../utilFunctions/transformFunc'
import Preview from '../../Cards/ChaPreview'
import {
  FieldRow,
  Layout,
  LeftColumn,
  RightColumn,
} from '../../forms/ChallengeForm/style'

import {
  CheckboxField,
  CounterContainer,
  ListContainer,
  ListItem,
  Photo,
} from './styles'

const ParticipantsList = () => {
  const { formState, updateParticipant, error: chaError } = useChallenge()
  const { students } = useStudents()

  const handleUpdate = async (studentId: string) => {
    try {
      const res = await updateParticipant(studentId)

      toast.success(res?.message ?? 'Participante agregado')
    } catch (error) {
      console.log(error)
      toast.error(chaError)
    }
  }
  return (
    <Section
      title="Participantes"
      childrenClass="full-space-section"
      style={{ overflowY: 'scroll', paddingBottom: 0 }}
      withBackBtn={true}
      backURL="/desafios"
    >
      <Layout>
        <RightColumn style={{ paddingLeft: 20 }}>
          <SectionSubtitle fontSize={16} fontWeight={600}>
            <CounterContainer>
              <p>{formState.title}</p>
              <p className="subtitle">Ah-plausos: {formState.points} puntos</p>
            </CounterContainer>
          </SectionSubtitle>
          <FieldRow>
            <ListContainer>
              {students.map((student) => {
                return (
                  <ListItem key={student.uid}>
                    <Photo
                      $img={student.image || '/assets/profile.png'}
                      aria-label={student.name}
                    />
                    <CheckboxField
                      id="participants"
                      label={`${capitalizeFirstLetter(student.name)} ${capitalizeFirstLetter(student.lastname)}`}
                    >
                      <Input
                        id={student.uid}
                        name="participants"
                        defaultChecked={formState.participants.includes(
                          student.uid,
                        )}
                        type="checkbox"
                        onChange={() => handleUpdate(student.uid)}
                        disabled={formState.status === ChallengeStatus.UPCOMING}
                      />
                    </CheckboxField>
                  </ListItem>
                )
              })}
            </ListContainer>
          </FieldRow>

          <CounterContainer>
            <p>Participantes totales</p>
            <p>{formState.participants.length}</p>
          </CounterContainer>
        </RightColumn>
        <LeftColumn>
          <Preview />
        </LeftColumn>
      </Layout>
    </Section>
  )
}

export default ParticipantsList
